module.exports = new __parcel__URL__("space_desktop.aa59e7f3.mp4").toString();